<template>
  <AtomsLoaderUI v-if="isLoading" :isOpaque="loaderOpacity" />
</template>

<script setup lang="ts">
const isLoading = useLoaderState()
const loaderOpacity = useLoaderOpacity()
const route = useRoute()
if ((route.name! as string)?.includes('preview')) {
  isLoading.value = true
}
</script>
